module.exports = __webpack_public_path__ + "static/img/ddc_location_map.e7d2773f.jpg";